export default "__VITE_ASSET__BF9eYN6L__"